import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowBottomIcon = function SvgArrowBottomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "zig-icon"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.293 9.29302L12 13.586L7.70701 9.29302C7.51841 9.11086 7.26581 9.01007 7.00361 9.01235C6.74141 9.01462 6.4906 9.11979 6.30519 9.3052C6.11978 9.49061 6.01461 9.74142 6.01234 10.0036C6.01006 10.2658 6.11085 10.5184 6.29301 10.707L11.293 15.707C11.4805 15.8945 11.7348 15.9998 12 15.9998C12.2652 15.9998 12.5195 15.8945 12.707 15.707L17.707 10.707C17.8025 10.6148 17.8787 10.5044 17.9311 10.3824C17.9835 10.2604 18.0111 10.1292 18.0123 9.99642C18.0134 9.86364 17.9881 9.73196 17.9378 9.60907C17.8876 9.48617 17.8133 9.37452 17.7194 9.28063C17.6255 9.18673 17.5139 9.11248 17.391 9.0622C17.2681 9.01192 17.1364 8.98662 17.0036 8.98777C16.8708 8.98892 16.7396 9.01651 16.6176 9.06892C16.4956 9.12133 16.3853 9.19751 16.293 9.29302Z",
    fill: props.color
  }));
};

export { SvgArrowBottomIcon as ReactComponent };
